export enum OrganizationType {
  MIGEPROF = 'MIGEPROF',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
  PARTNER = 'PARTNER',
}
